
export const COLOR_BLACK = '#000000'
export const COLOR_YELLOW = '#F4C70B'
export const BG_BLUE  = '#072F4F'

